<div class="favorite-wrapper gtm-favorite" [attr.data-gtmlabel]="gtmLabel">
    <app-link-button
        class="favorite selenium-favorite"
        [hideLabelOnTablet]="hideLabelOnTablet"
        [hideLabelOnSmallDevices]="hideLabelOnSmallDevices"
        [hideLabelOnMobile]="hideLabelOnMobile"
        [ngClass]="{ large: isLarge }"
        [tooltip]="userService.isLoggedIn() ? loggedinTooltip : loggedoutTooltip"
        label="Favorite"
        [icon]="favoriteId ? 'FavoriteFilled' : 'Favorite'"
        (trigger)="onFavoriteClick()"
    >
    </app-link-button>
</div>
